import React from 'react';
import { Button, Result } from 'antd';

let NoPageComponent = (props) => {
  const navToHomePage = () => {
    props.navigate('/rubus/LandingPage');
  };

  return (
    <div>
      <Result
        status="500"
        title=""
        subTitle={<div style={{ color: "white" }}>{"Sorry, something went wrong."}</div>}
        extra={<Button onClick={() => navToHomePage()} type="primary">Back Home</Button>}
      />
    </div>
  );

};

export default NoPageComponent;